import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-no-data-container',
  templateUrl: './no-data-container.component.html',
  styleUrls: ['./no-data-container.component.css'],
})
export class NoDataContainerComponent {
  @Input() firstParagraph = '';
  @Input() secondParagraph = '';
  @Input() isChartCard = false;
}
